import { NgModule } from '@angular/core'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { RouterLink } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { SharedModule } from './shared/shared.module'
import { DashboardComponent } from './dashboard/dashboard.component'
import { CoreModule } from './core/core.module'
import { ForgotPasswordComponent } from './landingpage/forgot-password/forgot-password.component'
import { HomeComponent } from './landingpage/home/home.component'
import { LoginComponent } from './landingpage/login/login.component'


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    RouterLink,
    CoreModule.forRoot(),
    SharedModule,
    HomeComponent,
    LoginComponent,
    ForgotPasswordComponent,
    DashboardComponent
  ],
  providers: [Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
